import React from 'react';
import classnames from 'classnames';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import SelectedSearchItemTag from './SelectedSearchItemTag';
import MoreLessButton from './MoreLessButton';

import './SelectedSearchItems.custom.scss';
import './SelectedSearchItems.theme.scss';

function SelectedSearchItems(props) {
  const {
    tags,
    expandSearchOptions,
  } = props;
  const tagsCount = tags.count();

  if (tagsCount === 0) {
    return null;
  }

  const moreClass = expandSearchOptions ?
    'tree-view-dialog-selected-search-items-wrapper-more' :
    'tree-view-dialog-selected-search-items-wrapper-less';

  return (
    <section className={classnames(
      'tree-view-dialog-selected-search-items',
      {
        ['tree-view-dialog-selected-search-items-more']: expandSearchOptions
      }
      )}>
      <h4 className='tree-view-dialog-selected-search-items-title'>
        Selected search items:
        <MoreLessButton
          {...props}
          tagsCount={tagsCount}
        />
      </h4>
      <div className={classnames(
        'tree-view-dialog-selected-search-items-wrapper',
        moreClass,
      )}>
        {
          tags
            .map((item) => {
              const id = item.get('id');

              return (
                <SelectedSearchItemTag
                  {...props}
                  key={id}
                  item={item}
                />
              );
            })
        }
      </div>
    </section>
  );
}

SelectedSearchItems.propTypes = {
  tags: PropTypes.instanceOf(List),
  expandSearchOptions: PropTypes.bool.isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
  onToggleSearchOptions: PropTypes.func.isRequired,
};


export default SelectedSearchItems;

